import React from "react";

/**
 * Skeleton-плейсхолдер карточки идеи. Показывается пока грузится /sections
 * или /ideas. Лучше чем «Загрузка…» текстом — визуально подсказывает что
 * сейчас придёт.
 */
export default function IdeaCardSkeleton({ count = 3 }) {
    return (
        <div className="idz-row">
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className="idz-skel-card">
                    <div className="idz-skel-line t" />
                    <div className="idz-skel-line s" />
                    <div className="idz-skel-line s2" />
                    <div className="idz-skel-line f" />
                </div>
            ))}
        </div>
    );
}
